import { get_thunk, post_thunk } from 'services/Api';

import {
  ACCOUNTS_GET_ALL,
  ACCOUNT_ADD_NEW,
} from 'features/home/core/ReduxNames';
import {
  ENDPOINT_ADD_ACCOUNT,
  ENDPOINT_GET_ACCOUNTS,
} from 'services/Endpoints';

const getAccounts = get_thunk(ACCOUNTS_GET_ALL, ENDPOINT_GET_ACCOUNTS);
const addAccount = post_thunk(ACCOUNT_ADD_NEW, ENDPOINT_ADD_ACCOUNT);

export { addAccount };
export default getAccounts;
